import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import Range from 'Components/Range';
import { Typography } from 'Components/Typography';

const Card = styled('div')({
  backgroundColor: theme.colors.neutral[100],
  padding: `${legacyTheme.spacing.s16} ${legacyTheme.spacing.s24}`,
  marginBottom: `${legacyTheme.spacing.s16}`,
});

const FragranceName = styled(Typography)`
  margin-bottom: 4px;
`;

const TestimonyTitle = styled(Typography)`
  margin-top: ${legacyTheme.spacing.s16};
`;

export type FragranceTestimony = {
  by: string;
  dataTestId?: string;
  fragranceName: string;
  intensity: number;
  notes: string;
  testimony: string;
  title: string;
};

export const FragranceTestimonyCard = ({
  by,
  dataTestId,
  fragranceName,
  intensity,
  notes,
  testimony,
  title,
}: FragranceTestimony) => (
  <Card data-testid={dataTestId} id={fragranceName}>
    <FragranceName align="center" color="noir" variant="mono2">
      {title}
    </FragranceName>
    <Typography align="center" color="grey" variant="mono3">
      {notes}
    </Typography>
    <TestimonyTitle align="center" color="noir" medium paragraph variant="p2">
      Smells like:
    </TestimonyTitle>
    <Typography align="center" color="noir" paragraph variant="p2">
      {testimony} {by.length > 0 && `-${by}`}
    </Typography>
    <Range labels={['Subtle', 'Strong']} value={intensity} />
  </Card>
);
